// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2N6fA","col":"styles_col__3ns6k"};